// Evidence fixtures (CLAIMS_UI_BUILD_SPEC §14.3). Tables never name other patients.
import type { Evidence } from './types';

export const EVIDENCE: Record<string, Evidence> = {
  'ev-aetna-perio': {
    id: 'ev-aetna-perio',
    title: '9 Aetna claims denied without a perio chart',
    summary:
      'Each billed D2950 with a crown and no periodontal chart, Jan–Sep 2026. All 9 were denied.',
    table: [
      { claim: 'CLM-0412', date: 'Jan 21, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0477', date: 'Feb 9, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0531', date: 'Mar 3, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0588', date: 'Apr 14, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0644', date: 'May 19, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0702', date: 'Jun 23, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0781', date: 'Jul 28, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0860', date: 'Aug 25, 2026', outcome: 'Denied — no perio chart' },
      { claim: 'CLM-0981', date: 'Sep 29, 2026', outcome: 'Denied — no perio chart' },
    ],
  },
  'ev-metlife-7140': {
    id: 'ev-metlife-7140',
    title: 'MetLife paid 89 of your D7140 claims since Jan 2025',
    summary: 'None denied. Average payment $211.',
  },
  'ev-aetna-2391': {
    id: 'ev-aetna-2391',
    title: 'Aetna paid 214 of your D2391 claims since Jan 2025',
    summary: 'None denied. Average payment $149.',
  },
  'ev-delta-0150': {
    id: 'ev-delta-0150',
    title: 'Delta paid 41 of your D0150 + D0210 claims since Jan 2025',
    summary: 'One denied for frequency, none since. Average payment $181.',
  },
  'ev-metlife-1110': {
    id: 'ev-metlife-1110',
    title: 'MetLife paid 312 of your cleaning-and-exam claims since Jan 2025',
    summary: 'Two denied for frequency. Average payment $219.',
  },
  'ev-pa-3299': {
    id: 'ev-pa-3299',
    title: 'Pre-auth PA-3299 · Delta Dental',
    summary: 'Approved Sep 18, 2026 for D6010 on #30. Valid until Mar 18, 2027.',
  },
  'ev-kim-elig': {
    id: 'ev-kim-elig',
    title: 'Eligibility check · Oct 10, 2026',
    summary: 'Cigna: ended Sep 30, 2026. Guardian: active since Oct 1, 2026.',
  },
  'ev-price-elig': {
    id: 'ev-price-elig',
    title: 'Eligibility check · Nov 17, 2026',
    summary: 'Cigna: ended Oct 31, 2026. Guardian: active since Nov 1, 2026.',
  },
  'ev-ready-filler': {
    id: 'ev-ready-filler',
    title: 'Checked against how this payer paid claims like this one',
    summary:
      'Codes, tooth and documentation match the payer’s rules and how it paid your recent claims of the same kind. None were denied.',
  },
};
